<template>
    <div class="modal fade" id="costumModalsinkronisasi" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
        aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
        style="margin: auto;">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Sinkronisasi Data Emon</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-justify">
                    <p>
                    <div class="row">
                        <div class="col-sm-6">
                            <label>OWP (Rp.)</label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" name="radioOWP" checked
                                            @click="rubahowp('OWPlokal')">
                                    </div>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="OWPlokal" name="OWPlokal"
                                    placeholder="OWP" v-model="OWP" disabled>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <label>OWP Emon (Rp.)</label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" name="radioOWP"
                                            @click="rubahowp('OWPEmon')">
                                    </div>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="OWPEmon" name="OWPEmon"
                                    placeholder="OWP" v-model="OWPEmon" disabled>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <label class="text-success">AWP</label>
                        </div>
                        <div class="col-sm-6 float-left">
                            <div class="col-sm-12 float-left" v-for="(datadata, urutdata) in AWP" :key="urutdata">
                                <label>AWP {{ datadata.Tahun }} (Rp.)</label>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio"
                                                :name="'radioAWP' + datadata.Tahun" checked
                                                @click="rubahsinkronisasi('AWPLokal' + datadata.Tahun, 'AWP' + datadata.Tahun)">
                                        </div>
                                    </div>
                                    <input type="text" class="form-control form-control-sm"
                                        :id="'AWPLokal' + datadata.Tahun" :name="'AWPLokal' + datadata.Tahun"
                                        placeholder="AWP" :value="G_numFormat(datadata.Nilai)"
                                        @keyup="formattulisrupiah('AWPLokal' + datadata.Tahun)"
                                        @keydown="formattulisrupiah('AWPLokal' + datadata.Tahun)" disabled>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 float-left">
                            <div class="col-sm-12 float-left" v-for="(datadata, urutdata) in AWPEmon" :key="urutdata">
                                <label>AWP Emon {{ datadata.Tahun }} (Rp.)</label>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio"
                                                :name="'radioAWP' + datadata.Tahun"
                                                @click="rubahsinkronisasi('AWPEmon' + datadata.Tahun, 'AWP' + datadata.Tahun)">
                                        </div>
                                    </div>
                                    <input type="text" class="form-control form-control-sm"
                                        :id="'AWPEmon' + datadata.Tahun" :name="'AWPEmon' + datadata.Tahun"
                                        placeholder="AWP" :value="G_numFormat(datadata.Nilai)"
                                        @keyup="formattulisrupiah('AWPEmon' + datadata.Tahun)"
                                        @keydown="formattulisrupiah('AWPEmon' + datadata.Tahun)" disabled>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <label class="text-success">DIPA</label>
                        </div>
                        <div class="col-sm-6 float-left">
                            <div class="col-sm-12 float-left" v-for="(datadata, urutdata) in DIPA" :key="urutdata">
                                <label>DIPA {{ datadata.Tahun }} (Rp.)</label>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio"
                                                :name="'radioDIPA' + datadata.Tahun" checked
                                                @click="rubahsinkronisasi('DIPALokal' + datadata.Tahun, 'DIPA' + datadata.Tahun)">
                                        </div>
                                    </div>
                                    <input type="text" class="form-control form-control-sm"
                                        :id="'DIPALokal' + datadata.Tahun" :name="'DIPALokal' + datadata.Tahun"
                                        placeholder="DIPA" :value="G_numFormat(datadata.Nilai)"
                                        @keyup="formattulisrupiah('DIPALokal' + datadata.Tahun)"
                                        @keydown="formattulisrupiah('DIPALokal' + datadata.Tahun)" disabled>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 float-left">
                            <div class="col-sm-12 float-left" v-for="(datadata, urutdata) in DIPAEmon" :key="urutdata">
                                <label>DIPA {{ datadata.Tahun }} (Rp.)</label>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio"
                                                :name="'radioDIPA' + datadata.Tahun"
                                                @click="rubahsinkronisasi('DIPAEmon' + datadata.Tahun, 'DIPA' + datadata.Tahun)">
                                        </div>
                                    </div>
                                    <input type="text" class="form-control form-control-sm"
                                        :id="'DIPAEmon' + datadata.Tahun" :name="'DIPAEmon' + datadata.Tahun"
                                        placeholder="DIPA" :value="G_numFormat(datadata.Nilai)"
                                        @keyup="formattulisrupiah('DIPAEmon' + datadata.Tahun)"
                                        @keydown="formattulisrupiah('DIPAEmon' + datadata.Tahun)" disabled>
                                </div>
                            </div>
                        </div>
                    </div>
                    </p>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-danger3 btn-sm lebar2 text-white" data-dismiss="modal"> <i
                            class="far fa-times-circle"></i>
                        Tutup</button>
                </div>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
    <div class="wrapper">
        <NavBar />
        <Menu />
        <!-- Spinner Start -->
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
            style="opacity: 0.5;">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="content-wrapper py-3">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6 wow fadeInDown">
                            <h5>Pengaturan</h5>
                        </div>
                        <div class="col-sm-6 wow fadeInDown">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a href="/Dashboard">Home </a></li>
                                <li class="breadcrumb-item"><a href="/Environment">Environment Proyek</a></li>
                                <li class="breadcrumb-item active">Pengaturan Environment Proyek</li>
                            </ol>
                        </div>
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12 wow fadeInDown">
                            <div class="card cardputih2">
                                <div class="card-header border-transparent">
                                    <h3 class="card-title">Form Input Environment Proyek</h3>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body p-3">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <div class="card card-success collapsed-card">
                                                <div class="card-header border-transparent"
                                                    style="cursor: pointer;background-color: #005c95 !important;"
                                                    data-card-widget="collapse">
                                                    <h3 class="card-title text-white">1. INFORMASI PAKET PEKERJAAN</h3>
                                                    <div class="card-tools">
                                                        <button type="button" class="btn btn-tool"
                                                            data-card-widget="collapse">
                                                            <i class="fas fa-plus"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="card-body p-3">
                                                    <div class="row">
                                                        <div class="col-sm-12 float-left">
                                                            <label>PIU <small class="text-info"> (*wajib
                                                                    dipilih)</small></label>
                                                            <v-select :options="id_user" :reduce="(label) => label.code"
                                                                label="label" v-model="defaultSelectedid_user"
                                                                @update:modelValue="onid_userChange"
                                                                style="background-color: #ffffff;" disabled></v-select>
                                                        </div>
                                                        <div class="col-sm-12">&nbsp;</div>
                                                        <div class="col-sm-12 float-left">
                                                            <label>Satker <small class="text-info"> (*wajib
                                                                    dipilih)</small></label>
                                                            <v-select :options="satker" :reduce="(label) => label.code"
                                                                label="label" v-model="defaultSelectedsatker"
                                                                @update:modelValue="onsatkerChange"
                                                                style="background-color: #ffffff;" disabled></v-select>
                                                        </div>
                                                        <div class="col-sm-6 float-left" style="display: none;">
                                                            <label>Nama Kegiatan PMIS <small class="text-info"> (*wajib
                                                                    dipilih)</small></label>
                                                            <v-select :options="idpmis" :reduce="(label) => label.code"
                                                                label="label" v-model="defaultSelectedidpmis"
                                                                @update:modelValue="onidpmisChange"
                                                                style="background-color: #ffffff;" disabled></v-select>
                                                        </div>
                                                        <div class="col-sm-12">&nbsp;</div>
                                                        <div class="col-sm-6">
                                                            <label>Nama Kegiatan <small class="text-info"> (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    id="Nama_Kegiatan" name="Nama_Kegiatan"
                                                                    placeholder="Nama Kegiatan" v-model="Nama_Kegiatan"
                                                                    disabled>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6 float-left">
                                                            <label>Lokasi<small class="text-info"> (*wajib
                                                                    dipilih)</small></label>
                                                            <v-select :options="lokasi" :reduce="(label) => label.code"
                                                                label="label" v-model="defaultSelectedlokasi"
                                                                @update:modelValue="onlokasiChange"
                                                                style="background-color: #ffffff;" disabled></v-select>
                                                        </div>
                                                        <div class="col-sm-12 text-center" style="display: none;">
                                                            <button type="button"
                                                                class="btn btn-danger3 btn-sm text-white"
                                                                @click="sinkorinasi()"> <i
                                                                    class="fas fa-arrows-alt-h"></i>
                                                                Sinkronisasi / Ambil Data Emon</button>
                                                        </div>

                                                        <div class="col-sm-6">
                                                            <label>Komponen / Output<small class="text-info"> (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    id="Komponen" name="Komponen" placeholder="Komponen"
                                                                    v-model="Komponen" disabled>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <label>Sub Komponen<small class="text-info"> (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    id="SubKomponen" name="SubKomponen"
                                                                    placeholder="Sub Komponen" v-model="SubKomponen"
                                                                    disabled>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6 float-left">
                                                            <label>Jenis Pekerjaan <small class="text-info"> (*wajib
                                                                    dipilih)</small></label>
                                                            <v-select :options="jenispekerjaan"
                                                                :reduce="(label) => label.code" label="label"
                                                                v-model="defaultSelectedjenispekerjaan"
                                                                @update:modelValue="onjenispekerjaanChange"
                                                                style="background-color: #ffffff;" disabled></v-select>
                                                        </div>
                                                        <div class="col-sm-6 float-left">
                                                            <label>Bank Review <small class="text-info"> (*wajib
                                                                    dipilih)</small></label>
                                                            <v-select :options="bankreview"
                                                                :reduce="(label) => label.code" label="label"
                                                                v-model="defaultSelectedbankreview"
                                                                @update:modelValue="onbankreviewChange"
                                                                style="background-color: #ffffff;" disabled></v-select>
                                                        </div>
                                                        <div class="col-sm-12">&nbsp;</div>
                                                        <div class="col-sm-6">
                                                            <label>Penyedia<small class="text-info"> (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    id="Penyedia" name="Penyedia" placeholder="Penyedia"
                                                                    disabled>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <label>Nilai Kontrak (Rp.)<small class="text-info"> (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    id="Nilai" name="Nilai" placeholder="Nilai Kontrak"
                                                                    @keyup="formattulisrupiah('Nilai')"
                                                                    @keydown="formattulisrupiah('Nilai')" disabled>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <label>Mulai Kontrak<small class="text-info"> (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="date" class="form-control form-control-sm"
                                                                    id="Mulai" name="Mulai" placeholder="Mulai Kontrak"
                                                                    disabled>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <label>Selesai Kontrak<small class="text-info"> (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="date" class="form-control form-control-sm"
                                                                    id="Selesai" name="Selesai"
                                                                    placeholder="Selesai Kontrak" disabled>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <label>Nomor Kontrak<small class="text-info"> (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    id="Kontrak" name="Kontrak"
                                                                    placeholder="Nomor Kontrak" disabled>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <label>Adendum</label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    id="Adendum" name="Adendum" placeholder="Adendum"
                                                                    disabled>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <template
                                            v-for="(datalistenvironmental, urutlistenvironmental) in environmental"
                                            :key="urutlistenvironmental">
                                            <div class="col-sm-12">
                                                <div class="card card-teal collapsed-card">
                                                    <div class="card-header border-transparent" style="cursor: pointer;"
                                                        :style="'background-color:' + datalistenvironmental.warna"
                                                        data-card-widget="collapse">
                                                        <h3 class="card-title"
                                                            :style="'color:' + datalistenvironmental.color">
                                                            {{ datalistenvironmental.urutan }}.
                                                            {{ datalistenvironmental.nama }}</h3>
                                                        <div class="card-tools">
                                                            <button type="button" class="btn btn-tool"
                                                                data-card-widget="collapse">
                                                                <i class="fas fa-plus"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div class="card-body p-3">
                                                        <div class="row">
                                                            <div class="col-sm-12 float-left"
                                                                v-if="datalistenvironmental.tipe == 'LIST'">
                                                                <div class="table-responsive table-wrapper">
                                                                    <table class="table m-0" id="tabeldata"
                                                                        style="font-size: small;">
                                                                        <thead>
                                                                            <tr>
                                                                                <th style="width: 50px;">No</th>
                                                                                <th style="width: 50px;">Bulan ke-</th>
                                                                                <th style="width: 100px;">Status Report
                                                                                </th>
                                                                                <th style="width: 50px;">Tanggal</th>
                                                                                <th style="width: 250px;">Dokumen</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <template
                                                                            v-for="(datalist, urutlist) in datadetail"
                                                                            :key="urutlist">
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td class="text-center">{{ urutlist
                                                                                        + 1
                                                                                    }}</td>
                                                                                    <td class="text-center">{{
                                                                                        datalist.bulan_ke }}</td>
                                                                                    <td class="text-center">
                                                                                        <select
                                                                                            class="form-control form-control-sm custom-select"
                                                                                            @change="cekisi('select' + datalist.id)"
                                                                                            :id="'select' + datalist.id">
                                                                                            <template
                                                                                                v-for="(datapilihannya, urutpilihannya) in Screening_Form"
                                                                                                :key="urutpilihannya">
                                                                                                <option
                                                                                                    :value="datapilihannya.tag"
                                                                                                    :selected="datapilihannya.tag == datalist.statusnya">
                                                                                                    {{
                                                                                                        datapilihannya.label
                                                                                                    }}
                                                                                                </option>
                                                                                            </template>
                                                                                        </select>
                                                                                    </td>
                                                                                    <td class="text-center">
                                                                                        <input type="date"
                                                                                            class="form-control form-control-sm"
                                                                                            :id="'tanggal' + datalist.id"
                                                                                            :name="'tanggal' + datalist.id"
                                                                                            placeholder="Date"
                                                                                            :value="datalist.tanggal">
                                                                                    </td>
                                                                                    <td class="text-left">
                                                                                        <a :href="folder_foto + datalist.filenya_environment"
                                                                                            target="_blank"
                                                                                            v-if="datalist.filenya_environment != '' && datalist.filenya_environment != null">Lihat
                                                                                            Dokumen</a> <br></br>
                                                                                        <input type="hidden"
                                                                                            class="form-control form-control-sm"
                                                                                            :id="'filenya_environment' + datalist.id"
                                                                                            :name="'filenya_environment' + datalist.id"
                                                                                            placeholder="Dokument"
                                                                                            readonly
                                                                                            :value="(datalist.filenya_environment)">
                                                                                        <input type="file"
                                                                                            class="form-control form-control-sm"
                                                                                            :id="'fileToUploadfilenya_environment' + datalist.id"
                                                                                            :name="'fileToUploadfilenya_environment' + datalist.id"
                                                                                            placeholder="fileToUpload"
                                                                                            style="font-size: smaller;"
                                                                                            accept="application/pdf">
                                                                                        <br>
                                                                                        <div class="progress">
                                                                                            <div class="progress-bar"
                                                                                                role="progressbar"
                                                                                                aria-valuenow="0"
                                                                                                aria-valuemin="0"
                                                                                                aria-valuemax="100"
                                                                                                style="width:0%"
                                                                                                :id="'persennyafilenya_environment' + datalist.id">
                                                                                                <span
                                                                                                    :id="'tulisanpersenfilenya_environment' + datalist.id">0%</span>
                                                                                            </div>
                                                                                        </div>
                                                                                        <br>
                                                                                        <span class="text-success"
                                                                                            :id="'suksesnyafilenya_environment' + datalist.id"></span>
                                                                                        <br>
                                                                                        <button type="button"
                                                                                            class="btn btn-warning btn-sm lebar text-white"
                                                                                            @click="uploadfiledetail('filenya_environment' + datalist.id, 'application/pdf')">Upload
                                                                                            File</button>
                                                                                        <button type="button"
                                                                                            class="btn btn-danger btn-sm lebar"
                                                                                            @click="clearfilepetadetail('filenya_environment' + datalist.id)">Hapus
                                                                                            File</button>
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </template>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                            <div class="col-sm-12 float-left" v-else>
                                                                <template
                                                                    v-for="(detailenvironmental, urutdetailenvironmental) in datalistenvironmental.detail"
                                                                    :key="urutdetailenvironmental">
                                                                    <div class="row"
                                                                        v-if="detailenvironmental.tipe == 'OPSI'">
                                                                        <div class="col-sm-12 float-left">
                                                                            <label>
                                                                                {{ datalistenvironmental.urutan }}.{{
                                                                                    urutdetailenvironmental + 1 }}. {{
                                                                                    detailenvironmental.nama }}
                                                                            </label>
                                                                        </div>
                                                                        <div class="col-sm-6 float-left">
                                                                            <label class="text-info">
                                                                                a. Status
                                                                            </label>
                                                                            <select
                                                                                class="form-control form-control-sm custom-select"
                                                                                @change="cekisi('progres' + detailenvironmental.id)"
                                                                                :id="'progres' + detailenvironmental.id">
                                                                                <template
                                                                                    v-for="(datapilihannya, urutpilihannya) in Screening_Form"
                                                                                    :key="urutpilihannya">
                                                                                    <option :value="datapilihannya.tag"
                                                                                        :selected="datapilihannya.tag == detailenvironmental.progres">
                                                                                        {{
                                                                                            datapilihannya.label
                                                                                        }}
                                                                                    </option>
                                                                                </template>
                                                                            </select>
                                                                        </div>
                                                                        <div class="col-sm-6 float-left">
                                                                            <label class="text-info">
                                                                                b. Tanggal
                                                                            </label>
                                                                            <input type="date"
                                                                                class="form-control form-control-sm"
                                                                                :id="'tanggalenv' + detailenvironmental.id"
                                                                                :name="'tanggalenv' + detailenvironmental.id"
                                                                                placeholder="Date"
                                                                                :value="detailenvironmental.tanggal">
                                                                        </div>
                                                                        <div class="col-sm-12 float-left">
                                                                            <br></br>
                                                                            <label class="text-info">
                                                                                c. Dokumen
                                                                            </label>
                                                                            <div class="row">
                                                                                <div class="col-sm-12">
                                                                                    <a :href="folder_foto + detailenvironmental.filenya_environment"
                                                                                        target="_blank"
                                                                                        v-if="detailenvironmental.filenya_environment != '' && detailenvironmental.filenya_environment != null">Lihat
                                                                                        Dokumen</a>
                                                                                    <input type="hidden"
                                                                                        class="form-control form-control-sm"
                                                                                        :id="'filenya_environmentdetail' + detailenvironmental.id"
                                                                                        :name="'filenya_environmentdetail' + detailenvironmental.id"
                                                                                        placeholder="Dokument" readonly
                                                                                        :value="(detailenvironmental.filenya_environment)">
                                                                                    <input type="file"
                                                                                        class="form-control form-control-sm"
                                                                                        :id="'fileToUploadfilenya_environmentdetail' + detailenvironmental.id"
                                                                                        :name="'fileToUploadfilenya_environmentdetail' + detailenvironmental.id"
                                                                                        placeholder="fileToUpload"
                                                                                        style="font-size: smaller;"
                                                                                        accept="application/pdf">
                                                                                </div>
                                                                                <div class="col-sm-12">
                                                                                    <br></br>
                                                                                    <small>Opsi</small>
                                                                                    <div class="row">
                                                                                        <div class="col-sm-9">
                                                                                            <div class="progress">
                                                                                                <div class="progress-bar"
                                                                                                    role="progressbar"
                                                                                                    aria-valuenow="0"
                                                                                                    aria-valuemin="0"
                                                                                                    aria-valuemax="100"
                                                                                                    style="width:0%"
                                                                                                    :id="'persennyafilenya_environmentdetail' + detailenvironmental.id">
                                                                                                    <span
                                                                                                        :id="'tulisanpersenfilenya_environmentdetail' + detailenvironmental.id">0%</span>
                                                                                                </div>
                                                                                            </div>
                                                                                            <span class="text-success"
                                                                                                :id="'suksesnyafilenya_environmentdetail' + detailenvironmental.id"></span>
                                                                                        </div>
                                                                                        <div class="col-sm-3">
                                                                                            <button type="button"
                                                                                                class="btn btn-warning btn-sm lebar text-white"
                                                                                                @click="uploadfiledetail('filenya_environmentdetail' + detailenvironmental.id, 'application/pdf')">Upload
                                                                                                File</button>
                                                                                            <button type="button"
                                                                                                class="btn btn-danger btn-sm lebar"
                                                                                                @click="clearfilepetadetail('filenya_environmentdetail' + detailenvironmental.id)">Hapus
                                                                                                File</button>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-sm-12 float-left">
                                                                            <label class="text-info">
                                                                                d. Keterangan
                                                                            </label>
                                                                            <textarea rows="5" cols="40"
                                                                                class="form-control form-control-sm"
                                                                                :id="'keterangan' + detailenvironmental.id"
                                                                                :name="'keterangan' + detailenvironmental.id"
                                                                                :value="detailenvironmental.keterangan"></textarea>
                                                                        </div>
                                                                    </div>
                                                                    <hr>
                                                                    </hr>
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                                <div class="card-footer p-3">
                                    <button type="button" class="btn btn-sm btn-success3 float-left text-white lebar2"
                                        v-if="(secretencData != 'Tambah')" @click="update()" data-toggle="tooltip"
                                        data-placement="left" title="Update data.."><i class="fa fa-check-circle"></i>
                                        Update</button>
                                    <button type="button" class="btn btn-sm btn-danger3 float-left text-white lebar2"
                                        @click="batalproses()" data-toggle="tooltip" data-placement="left"
                                        title="Batalkan proses.."><i class="fas fa-window-close"></i>
                                        Batal</button>
                                </div>
                                <div class="card-footer p-3">&nbsp;</div>
                                <div class="col-sm-12">&nbsp;</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import vSelect from 'vue-select';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import { quillEditor } from 'vue3-quill';
import Footer from "../../componen/Footer.vue";
import NavBar from "../../componen/NavBar.vue";
import Menu from "../../componen/Menu.vue";

import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
export default {
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    components: {
        Footer, NavBar, Menu, vSelect, swal, quillEditor
    },
    data() {
        return {
            halamanloading: true,
            iduser: JSON.parse(localStorage.getItem("usistem")),
            leveluser: JSON.parse(localStorage.getItem("lsistem")),
            namauser: JSON.parse(localStorage.getItem("nmusistem")),
            levelinstansi: JSON.parse(localStorage.getItem("inssistem")),
            roleuser: JSON.parse(localStorage.getItem("rlsistem")),
            secretencData: decodeURIComponent(CryptoJS.AES.decrypt(this.route.params.id, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString(CryptoJS.enc.Utf8)),
            Nama_Kegiatan: '',
            Komponen: '',
            SubKomponen: '',
            id_user: [],
            dataid_user: [],
            defaultSelectedid_user: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedid_user: 0,

            jenispekerjaan: [],
            datajenispekerjaan: [],
            defaultSelectedjenispekerjaan: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedjenispekerjaan: 0,

            idpmis: [],
            dataidpmis: [],
            defaultSelectedidpmis: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedidpmis: 0,

            lokasi: [],
            datalokasi: [],
            defaultSelectedlokasi: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedlokasi: 0,

            Penyedia: '',
            Mulai: '',
            Selesai: '',
            Kontrak: 0,
            Nilai: 0,
            Adendum: '',
            OWP: '',
            OWPEmon: '',
            AWP: [],
            AWPEmon: [],
            DIPA: [],
            DIPAEmon: [],
            REALISASI: [],
            Target: 0,
            Capaian: 0,
            Realisasi: 0,
            TanggalData: new Date(),
            Keterangan: '',
            tahapanpekerjaan: [],
            filenya_tahapan: '',
            LATITUDE: '',
            LONGITUDE: '',
            kendala: '',
            tindaklanjut: '',
            validasi: false,

            satker: [],
            datasatker: [],
            defaultSelectedsatker: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '0',
            },
            selectedsatker: '0',

            bankreview: [],
            databankreview: [],
            defaultSelectedbankreview: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedbankreview: '',

            bankreview: [],
            databankreview: [],
            defaultSelectedbankreview: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedbankreview: '',

            Screening_Form: [],
            dataScreening_Form: [],
            defaultSelectedScreening_Form: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedScreening_Form: '',
            Environmental_Permit: [],
            dataEnvironmental_Permit: [],
            defaultSelectedEnvironmental_Permit: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedEnvironmental_Permit: '',
            Environmental_Doucument: '',
            Permit_Date: '',
            SupplementaryDocumentDate: '',

            SupplementaryDocumentStatus: [],
            dataSupplementaryDocumentStatus: [],
            defaultSelectedSupplementaryDocumentStatus: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedSupplementaryDocumentStatus: '',

            C_EMP_Date: '',
            C_EMP_Status: [],
            dataC_EMP_Status: [],
            defaultSelectedC_EMP_Status: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedC_EMP_Status: '',
            datadetail: [],
            project_id: process.env.VUE_APP_PROJECT_ID,

            pdfnyaScreening_Form: process.env.VUE_APP_URL_API + 'parastapainnovationenv-Screening_Form?f=',
            pdfnyaSupplementaryDocument: process.env.VUE_APP_URL_API + 'parastapainnovationenv-SupplementaryDocument?f=',
            pdfnyaC_EMP: process.env.VUE_APP_URL_API + 'parastapainnovationenv-C_EMP?f=',
            pdfnyaEnvironmental_Doucument: process.env.VUE_APP_URL_API + 'parastapainnovationenv-Environmental_Doucument?f=',
            pdfnyaEnvironmental_Permit: process.env.VUE_APP_URL_API + 'parastapainnovationenv-Environmental_Permit?f=',
            folder_foto: process.env.VUE_APP_URL_API + 'parastapainnovationenv-PDF?f=',

            filenya_Screening_Form: '',
            filenya_SupplementaryDocument: '',
            filenya_C_EMP: '',
            filenya_Environmental_Doucument: '',
            filenya_Environmental_Permit: '',
            environmental: [],
        }
    },
    methods: {
        cekisi(isinya) {
            //alert(document.getElementById(isinya).value);
        },
        rubahowp(kode) {
            this.OWP = document.getElementById(kode).value;
        },
        rubahsinkronisasi(awal, akhir) {
            document.getElementById(akhir).value = document.getElementById(awal).value;
        },
        uploadfile(idnya, tipenya) {
            var elmnt = document.getElementById("fileToUpload" + idnya);
            try {
                var namanya = elmnt.files[0].name;
                //alert(elmnt.files[0]['type'].toUpperCase());
                if (tipenya == 'image/*') {
                    if ((elmnt.files[0]['type'].toUpperCase() != 'IMAGE/JPG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/JPEG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/PNG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/GIF')) {
                        document.getElementById('suksesnya' + idnya).innerHTML = '*file harus format gambar';
                        return;
                    }
                }
                else {
                    if (elmnt.files[0]['type'] != tipenya) {
                        document.getElementById('suksesnya' + idnya).innerHTML = '*file harus format pdf';
                        return;
                    }
                }
            } catch (error) {
                document.getElementById('suksesnya' + idnya).innerHTML = '*pilih file terlebih dahulu';
                return;
            }
            var fd = new FormData();
            fd.append("fileToUpload", elmnt.files[0], elmnt.files[0].name);
            fd.append("folderToUpload", idnya);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovationpeta-FilesUpload", fd, {
                onUploadProgress: function (uploadEvent) {
                    document.getElementById('persennya' + idnya).style.width = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                    document.getElementById('tulisanpersen' + idnya).innerHTML = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                }
            }).then(
                function (res) {
                    document.getElementById('suksesnya' + idnya).innerHTML = res.data.message;
                    if (res.data.filename != undefined) {
                        document.getElementById(idnya).value = res.data.filename;
                    }
                }
            ).catch(function (e) {
                document.getElementById('suksesnya' + idnya).innerHTML = res.data.message;
                document.getElementById(idnya).value = '';
                console.log(e);
            }
            )
        },
        clearfilepeta(idnya) {
            if (document.getElementById(idnya).value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'File Tidak Tersedia',
                });
                return false;
            }

            var fd = new FormData();
            fd.append("folderToUpload", idnya);
            fd.append("filenya", document.getElementById(idnya).value);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovationpeta-FilesDeleted", fd).then(
                Response => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: Response.data.message,
                    });
                    $('.swal2-container').css("z-index", '999999');
                    document.getElementById(idnya).value == '';
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
                $('.swal2-container').css("z-index", '999999');
            }
            )

            document.getElementById('fileToUpload' + idnya).value = '';
            document.getElementById(idnya).value = '';
            document.getElementById('persennya' + idnya).style.width = "0%";
            document.getElementById('tulisanpersen' + idnya).innerHTML = "0%";
            document.getElementById('suksesnya' + idnya).innerHTML = '';
            return false;
        },
        uploadfiledetail(idnya, tipenya) {
            var elmnt = document.getElementById("fileToUpload" + idnya);
            try {
                var namanya = elmnt.files[0].name;
                //alert(elmnt.files[0]['type'].toUpperCase());
                if (tipenya == 'image/*') {
                    if ((elmnt.files[0]['type'].toUpperCase() != 'IMAGE/JPG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/JPEG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/PNG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/GIF')) {
                        document.getElementById('suksesnya' + idnya).innerHTML = '*file harus format gambar';
                        return;
                    }
                }
                else {
                    if (elmnt.files[0]['type'] != tipenya) {
                        document.getElementById('suksesnya' + idnya).innerHTML = '*file harus format pdf';
                        return;
                    }
                }
            } catch (error) {
                document.getElementById('suksesnya' + idnya).innerHTML = '*pilih file terlebih dahulu';
                return;
            }
            var fd = new FormData();
            fd.append("fileToUpload", elmnt.files[0], elmnt.files[0].name);
            fd.append("folderToUpload", 'filenya_environment');
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovationpeta-FilesUpload", fd, {
                onUploadProgress: function (uploadEvent) {
                    document.getElementById('persennya' + idnya).style.width = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                    document.getElementById('tulisanpersen' + idnya).innerHTML = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                }
            }).then(
                function (res) {
                    document.getElementById('suksesnya' + idnya).innerHTML = res.data.message;
                    if (res.data.filename != undefined) {
                        document.getElementById(idnya).value = res.data.filename;
                    }
                }
            ).catch(function (e) {
                document.getElementById('suksesnya' + idnya).innerHTML = res.data.message;
                document.getElementById(idnya).value = '';
                console.log(e);
            }
            )
        },
        clearfilepetadetail(idnya) {
            if (document.getElementById(idnya).value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'File Tidak Tersedia',
                });
                return false;
            }

            var fd = new FormData();
            fd.append("folderToUpload", 'filenya_environment');
            fd.append("filenya", document.getElementById(idnya).value);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovationpeta-FilesDeleted", fd).then(
                Response => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: Response.data.message,
                    });
                    $('.swal2-container').css("z-index", '999999');
                    document.getElementById(idnya).value == '';
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
                $('.swal2-container').css("z-index", '999999');
            }
            )

            document.getElementById('fileToUpload' + idnya).value = '';
            document.getElementById(idnya).value = '';
            document.getElementById('persennya' + idnya).style.width = "0%";
            document.getElementById('tulisanpersen' + idnya).innerHTML = "0%";
            document.getElementById('suksesnya' + idnya).innerHTML = '';
            return false;
        },
        formattulisrupiah(kodenya) {
            var rupiah = document.getElementById(kodenya);
            rupiah.addEventListener('keyup', function (e) {
                // tambahkan 'Rp.' pada saat form di ketik
                // gunakan fungsi formatRupiah() untuk mengubah angka yang di ketik menjadi format angka
                rupiah.value = formatRupiah(this.value, '');
            });

            /* Fungsi formatRupiah */
            function formatRupiah(angka, prefix) {
                var separator = '';
                var number_string = angka.replace(/[^,\d]/g, '').toString(),
                    split = number_string.split(','),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);

                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    separator = sisa ? '.' : '';
                    rupiah += separator + ribuan.join('.');
                }

                rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
                return prefix == undefined ? rupiah : (rupiah ? rupiah : '');
            }
        },

        async ambildatareff() {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPI5.get("parastapainnovation_userproject-GetPIU?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.levelinstansi + "&role=" + this.roleuser).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataid_user = [];
                        this.id_user = [];
                        this.dataid_user = Response.data.content.data;
                        this.dataid_user.forEach((item) => {
                            this.id_user.push({
                                label: item.nama_satker,
                                code: this.dataid_user.indexOf(item) + 1,
                                tag: item.user_id,
                            });
                        });
                        this.id_user.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            if (this.roleuser == 'user') {
                var idadi = this.levelinstansi;
            }
            else {
                var idadi = '';
            }

            mainAPI5.get("parastapainnovation_userproject-GetSatker?random=" + random + "&project_id=" + this.project_id + "&id_user=" + idadi).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datasatker = [];
                        this.satker = [];
                        this.datasatker = Response.data.content.data;
                        this.datasatker.forEach((item) => {
                            this.satker.push({
                                label: item.namasatker,
                                code: this.datasatker.indexOf(item) + 1,
                                tag: item.kodesatker,
                            });
                        });
                        this.satker.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '0',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovation_jenispekerjaan-GetJenisPekerjaan?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datajenispekerjaan = [];
                        this.jenispekerjaan = [];
                        this.datajenispekerjaan = Response.data.content.data;
                        this.datajenispekerjaan.forEach((item) => {
                            this.jenispekerjaan.push({
                                label: item.nama,
                                code: this.datajenispekerjaan.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.jenispekerjaan.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });


            await mainAPI5.get("parastapainnovation_bankreview-Data?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.databankreview = [];
                        this.bankreview = [];
                        this.databankreview = Response.data.content.data;
                        this.databankreview.forEach((item) => {
                            this.bankreview.push({
                                label: item.nama,
                                code: this.databankreview.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.bankreview.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });


            await mainAPI5.get("parastapainnovationenv-NewReffProses?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataScreening_Form = [];
                        this.Screening_Form = [];
                        this.dataScreening_Form = Response.data.content.data;
                        this.dataScreening_Form.forEach((item) => {
                            this.Screening_Form.push({
                                label: item.nama,
                                code: this.dataScreening_Form.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.Screening_Form.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovationenv-Reff?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataC_EMP_Status = [];
                        this.C_EMP_Status = [];
                        this.dataC_EMP_Status = Response.data.content.data;
                        this.dataC_EMP_Status.forEach((item) => {
                            this.C_EMP_Status.push({
                                label: item.nama,
                                code: this.dataC_EMP_Status.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.C_EMP_Status.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovationenv-Reff?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataEnvironmental_Permit = [];
                        this.Environmental_Permit = [];
                        this.dataEnvironmental_Permit = Response.data.content.data;
                        this.dataEnvironmental_Permit.forEach((item) => {
                            this.Environmental_Permit.push({
                                label: item.nama,
                                code: this.dataEnvironmental_Permit.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.Environmental_Permit.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovationenv-NOL?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataSupplementaryDocumentStatus = [];
                        this.SupplementaryDocumentStatus = [];
                        this.dataSupplementaryDocumentStatus = Response.data.content.data;
                        this.dataSupplementaryDocumentStatus.forEach((item) => {
                            this.SupplementaryDocumentStatus.push({
                                label: item.nama,
                                code: this.dataSupplementaryDocumentStatus.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.SupplementaryDocumentStatus.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovation_tahapanpekerjaan-GetTahapanPekerjaan?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataStatus_pekerjaan = [];
                        this.Status_pekerjaan = [];
                        this.dataStatus_pekerjaan = Response.data.content.data;
                        this.dataStatus_pekerjaan.forEach((item) => {
                            this.Status_pekerjaan.push({
                                label: item.nama,
                                code: this.dataStatus_pekerjaan.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.Status_pekerjaan.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovation_lokasi-KotaProyek?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datalokasi = [];
                        this.lokasi = [];
                        this.datalokasi = Response.data.content.data;
                        this.datalokasi.forEach((item) => {
                            this.lokasi.push({
                                label: item.nama,
                                code: this.datalokasi.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.lokasi.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });


        },
        onid_userChange(a) {
            try {
                this.selectedid_user = this.id_user[a].tag;
            }
            catch (err) {
                return;
            }
            this.pilihKegiatanPMIS();
        },
        onjenispekerjaanChange(a) {
            try {
                this.selectedjenispekerjaan = this.jenispekerjaan[a].tag;
            }
            catch (err) {
                return;
            }
            this.AmbilTahapanPekerjaan();

            //alert(this.selectedjenispekerjaan);
        },
        onbankreviewChange(a) {
            try {
                this.selectedbankreview = this.bankreview[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onScreening_FormChange(a) {
            try {
                this.selectedScreening_Form = this.Screening_Form[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onC_EMP_StatusChange(a) {
            try {
                this.selectedC_EMP_Status = this.C_EMP_Status[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onEnvironmental_PermitChange(a) {
            try {
                this.selectedEnvironmental_Permit = this.Environmental_Permit[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onSupplementaryDocumentStatusChange(a) {
            try {
                this.selectedSupplementaryDocumentStatus = this.SupplementaryDocumentStatus[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onidpmisChange(a) {
            try {
                this.selectedidpmis = this.idpmis[a].tag;
            }
            catch (err) {
                return;
            }
        },
        async sinkorinasi() {
            //return false;
            if ((this.selectedid_user == '') || (this.selectedid_user == '0')) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Pilih PIU',
                });
                $('#costumModalsinkronisasi').modal('hide');
                //document.getElementById('customCheckboxSinkronisasi').checked = false;
                return false;
            }
            if ((this.selectedidpmis == '') || (this.selectedidpmis == '0')) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Pilih Kegiatan PMIS',
                });
                $('#costumModalsinkronisasi').modal('hide');
                //document.getElementById('customCheckboxSinkronisasi').checked = false;
                return false;
            }

            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPI5.get("parastapainnovationmonev-SinkronisasiPMIS?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.selectedid_user + "&id_kegiatan=" + this.selectedidpmis).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        $('#costumModalsinkronisasi').modal('show');
                        this.OWPEmon = this.G_numFormat(Response.data.content.data[0].anggaran_owp);
                        this.AWPEmon = Response.data.content.data[0].awp;
                        this.DIPAEmon = Response.data.content.data[0].dipa;
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
            //alert(this.selectedidpmis);
        },
        onlokasiChange(a) {
            try {
                this.selectedlokasi = this.lokasi[a].tag;
            }
            catch (err) {
                return;
            }
        },
        initialize() {
            //Initialize Select2 Elements
            $(".select2").select2();

            //Initialize Select2 Elements
            $(".select2bs4").select2({
                theme: "bootstrap4",
            });
            $('[data-mask]').inputmask();
            //$('#summernote').summernote();
        },
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                this.ClearlocalStorage();
            }
            this.halamanloading = false;
        },
        ontabelChange(a) {
            try {
                this.selectedtabel = this.tabel[a].tag;
            }
            catch (err) {
                return;
            }
        },
        batalproses() {
            var kode = encodeURIComponent(CryptoJS.AES.encrypt(this.secretencData, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Environment/" + kode);
        },
        async AmbilTahapanPekerjaan() {
            var mainAPIDataSingelcari = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            this.tahapanpekerjaan = [];
            await mainAPIDataSingelcari.get("parastapainnovation_tahapanpekerjaan-GetAll?random=" + random + "&project_id=" + this.project_id + "&jenis_pekerjaan=" + this.selectedjenispekerjaan + "&id_kegiatan=" + this.secretencData).then(
                Responsecari => {
                    this.tahapanpekerjaan = Responsecari.data.content.data;
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

        },
        async pilihKegiatanPMIS() {
            this.halamanloading = true;
            var mainAPIDataSingelcari = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPIDataSingelcari.get("parastapainnovation_idkegiatanpmis-GetIdKegiatanPMIS?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.selectedid_user).then(
                Responsecari => {
                    this.dataidpmis = [];
                    this.idpmis = [];
                    this.dataidpmis = Responsecari.data.content.data;
                    this.dataidpmis.forEach((item) => {
                        this.idpmis.push({
                            label: item.nama_kegiatan,
                            code: this.dataidpmis.indexOf(item) + 1,
                            tag: item.id_kegiatan,
                        });
                    });
                    this.idpmis.unshift({
                        label: 'Pilih Salah Satu',
                        code: 0,
                        tag: '',
                    });
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });


        },
        async AmbilDataSingel() {
            //alert(this.secretencData);
            this.halamanloading = true;
            var mainAPIDataSingel = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var mainAPIDataSingelcari = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });

            var tmp = this.secretencData.split("_");
            var terpilih = tmp[0];
            var random = Math.random();
            await mainAPIDataSingel.get("parastapainnovationenv-GetbyID?id=" + terpilih + "&random=" + random + "&project_id=" + this.project_id + "&create=" + JSON.parse(localStorage.getItem("isistem"))).then(
                Response => {
                    this.environmental = Response.data.content.data[0].environmental;
                    this.Nama_Kegiatan = Response.data.content.data[0].Nama_Kegiatan;
                    this.Komponen = Response.data.content.data[0].Komponen;
                    this.SubKomponen = Response.data.content.data[0].SubKomponen;
                    this.kendala = Response.data.content.data[0].kendala;
                    this.tindaklanjut = Response.data.content.data[0].tindaklanjut;
                    var id_userpmis = Response.data.content.data[0].id_user;
                    this.defaultSelectedid_user = {
                        code: Response.data.content.data[0].id_user,
                        label: Response.data.content.data[0].nama_satker,
                        tag: Response.data.content.data[0].id_user,
                    };
                    this.selectedid_user = Response.data.content.data[0].id_user;

                    if (this.selectedid_user != '') {
                        mainAPIDataSingelcari.get("parastapainnovation_userproject-GetSatker?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.selectedid_user).then(
                            Response => {
                                this.datapesan = Response.data.message;
                                //alert(this.datapesan);
                                if (this.datapesan == 'data diketemukan') {
                                    this.datasatker = [];
                                    this.satker = [];
                                    this.datasatker = Response.data.content.data;
                                    this.datasatker.forEach((item) => {
                                        this.satker.push({
                                            label: item.namasatker,
                                            code: this.datasatker.indexOf(item) + 1,
                                            tag: item.kodesatker,
                                        });
                                    });
                                    this.satker.unshift({
                                        label: 'Pilih Salah Satu',
                                        code: 0,
                                        tag: '0',
                                    });
                                }
                                this.halamanloading = false;
                            }
                        ).catch(error => {
                            console.log(error);
                            //this.ClearlocalStorage();
                            this.halamanloading = false;
                        });
                    }

                    var satkerpmis = Response.data.content.data[0].satker;
                    if (satkerpmis != '') {
                        this.defaultSelectedsatker = {
                            code: Response.data.content.data[0].satker,
                            label: Response.data.content.data[0].namasatker,
                            tag: Response.data.content.data[0].satker,
                        };
                        this.selectedsatker = Response.data.content.data[0].satker;
                    }

                    this.defaultSelectedjenispekerjaan = {
                        code: Response.data.content.data[0].tipe_work,
                        label: Response.data.content.data[0].Kategori,
                        tag: Response.data.content.data[0].tipe_work,
                    };
                    this.defaultSelectedbankreview = {
                        code: Response.data.content.data[0].BankReview,
                        label: Response.data.content.data[0].namaBankReview,
                        tag: Response.data.content.data[0].BankReview,
                    };
                    this.defaultSelectedStatus_pekerjaan = {
                        code: Response.data.content.data[0].idstatuspekerjaan,
                        label: Response.data.content.data[0].Status_pekerjaan,
                        tag: Response.data.content.data[0].idstatuspekerjaan,
                    };
                    this.defaultSelectedlokasi = {
                        code: Response.data.content.data[0].Lokasi,
                        label: Response.data.content.data[0].namalokasi,
                        tag: Response.data.content.data[0].Lokasi,
                    };

                    this.selectedlokasi = Response.data.content.data[0].Lokasi;

                    if (Response.data.content.data[0].Lokasi == '') {
                        this.defaultSelectedlokasi = {
                            code: 0,
                            label: 'Pilih Salah Satu',
                            tag: '',
                        };
                        this.selectedlokasi = '';
                    }

                    this.selectedjenispekerjaan = Response.data.content.data[0].tipe_work;
                    this.selectedbankreview = Response.data.content.data[0].BankReview;
                    this.selectedStatus_pekerjaan = Response.data.content.data[0].idstatuspekerjaan;
                    //alert(Response.data.content.data[0].id_pmis);

                    this.defaultSelectedScreening_Form = {
                        code: Response.data.content.data[0].Screening_Form,
                        label: Response.data.content.data[0].NamaScreening_Form,
                        tag: Response.data.content.data[0].Screening_Form,
                    };

                    this.selectedScreening_Form = Response.data.content.data[0].Screening_Form;
                    this.Environmental_Doucument = Response.data.content.data[0].Environmental_Doucument;
                    this.Permit_Date = Response.data.content.data[0].Permit_Date;
                    this.SupplementaryDocumentDate = Response.data.content.data[0].SupplementaryDocumentDate;

                    this.defaultSelectedEnvironmental_Permit = {
                        code: Response.data.content.data[0].Environmental_Permit,
                        label: Response.data.content.data[0].NamaEnvironmental_Permit,
                        tag: Response.data.content.data[0].Environmental_Permit,
                    };

                    this.selectedEnvironmental_Permit = Response.data.content.data[0].Environmental_Permit;

                    this.defaultSelectedSupplementaryDocumentStatus = {
                        code: Response.data.content.data[0].SupplementaryDocumentStatus,
                        label: Response.data.content.data[0].NamaSupplementaryDocumentStatus,
                        tag: Response.data.content.data[0].SupplementaryDocumentStatus,
                    };

                    this.selectedSupplementaryDocumentStatus = Response.data.content.data[0].SupplementaryDocumentStatus;
                    this.C_EMP_Date = Response.data.content.data[0].C_EMP_Date;

                    this.defaultSelectedC_EMP_Status = {
                        code: Response.data.content.data[0].C_EMP_Status,
                        label: Response.data.content.data[0].NamaC_EMP_Status,
                        tag: Response.data.content.data[0].C_EMP_Status,
                    };

                    this.selectedC_EMP_Status = Response.data.content.data[0].C_EMP_Status;

                    this.tahapanpekerjaan = [];
                    mainAPIDataSingelcari.get("parastapainnovation_tahapanpekerjaan-GetAll?random=" + random + "&project_id=" + this.project_id + "&jenis_pekerjaan=" + Response.data.content.data[0].tipe_work + "&id_kegiatan=" + this.secretencData).then(
                        Responsecari => {
                            this.tahapanpekerjaan = Responsecari.data.content.data;
                        }
                    ).catch(error => {
                        console.log(error);
                        //this.ClearlocalStorage();
                        this.halamanloading = false;
                    });

                    mainAPIDataSingelcari.get("parastapainnovation_idkegiatanpmis-GetIdKegiatanPMIS?random=" + random + "&project_id=" + this.project_id + "&id_user=" + id_userpmis).then(
                        Responsecari => {
                            this.dataidpmis = [];
                            this.idpmis = [];
                            this.dataidpmis = Responsecari.data.content.data;
                            this.dataidpmis.forEach((item) => {
                                this.idpmis.push({
                                    label: item.nama_kegiatan,
                                    code: this.dataidpmis.indexOf(item) + 1,
                                    tag: item.id_kegiatan,
                                });
                            });
                            this.idpmis.unshift({
                                label: 'Pilih Salah Satu',
                                code: 0,
                                tag: '',
                            });
                        }
                    ).catch(error => {
                        console.log(error);
                        //this.ClearlocalStorage();
                        this.halamanloading = false;
                    });

                    if ((Response.data.content.data[0].id_pmis == 0) || (Response.data.content.data[0].id_pmis == null) || (Response.data.content.data[0].id_pmis == '')) {
                        this.defaultSelectedidpmis = {
                            code: 0,
                            label: 'Pilih Salah Satu',
                            tag: '',
                        };
                    }
                    else {
                        this.defaultSelectedidpmis = {
                            code: Response.data.content.data[0].id_pmis,
                            label: Response.data.content.data[0].namakegiatanpmis,
                            tag: Response.data.content.data[0].id_pmis,
                        };
                        this.selectedidpmis = Response.data.content.data[0].id_pmis;
                    }

                    //this.Penyedia = Response.data.content.data[0].KONTRAKTOR;

                    document.getElementById('Penyedia').value = Response.data.content.data[0].KONTRAKTOR;
                    document.getElementById('Mulai').value = Response.data.content.data[0].MULAI;
                    document.getElementById('Selesai').value = Response.data.content.data[0].SELESAI;
                    document.getElementById('Kontrak').value = Response.data.content.data[0].NOKONTRAK;
                    document.getElementById('Nilai').value = this.G_numFormat(Response.data.content.data[0].NILAIKONTRAK);

                    document.getElementById('Adendum').value = Response.data.content.data[0].ADENDUM;
                    //this.Adendum = Response.data.content.data[0].ADENDUM;
                    this.OWP = this.G_numFormat(Response.data.content.data[0].OWP);
                    this.AWP = Response.data.content.data[0].AWP;
                    this.DIPA = Response.data.content.data[0].DIPA;
                    this.REALISASI = Response.data.content.data[0].REALISASI;
                    this.Capaian = Response.data.content.data[0].PROGRES;

                    this.datadetail = Response.data.content.data[0].detail;
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', error, 'error');
                this.halamanloading = false;
                return false;
            })
        },
        cekvalidasitahapan(kode) {
            //alert(kode);
            var arraycek = [];
            for (let x = 0; x < this.tahapanpekerjaan.length; x++) {
                for (let i = 0; i < this.tahapanpekerjaan[x].tahapan.length; i++) {
                    //alert(x-1);
                    arraycek.push(this.tahapanpekerjaan[x].tahapan[i].id);
                }
            }
            var index = arraycek.indexOf(kode);
            //alert(index);
            if (index > 0) {
                if (document.getElementById('Status_pekerjaan_' + arraycek[index - 1]).checked == false) {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Silahkan pilih terlebih dahulu tahapan sebelumnya..',
                    });
                    $('.swal2-container').css("z-index", '999999');
                    document.getElementById('Status_pekerjaan_' + kode).checked = false;
                }
            }
        },
        cektanggal(kode) {
            var tanggal = new Date(document.getElementById('Mulai' + kode).value);
            var sdtanggal = new Date(document.getElementById('Selesai' + kode).value);
            if (tanggal > sdtanggal) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Tanggal Mulai Tidak Boleh Lebih Besar..',
                });
                $('.swal2-container').css("z-index", '999999');
                return false;
            }
        },
        validasidata() {
            this.validasi = true;
            return;
        },
        update() {
            this.validasidata();
            if (this.validasi == false) {
                return false;
            }

            var tmp = this.secretencData.split("_");
            var terpilih = tmp[0];

            var id_kegiatan = '';
            var master = '';
            var detail = '';
            var tanggal = '';
            var progres = '';
            var filenya_environment = '';
            var keterangan = '';
            for (let i = 0; i < this.environmental.length; i++) {
                if (this.environmental[i].tipe == 'OPSI') {
                    for (let c = 0; c < this.environmental[i].detail.length; c++) {
                        if (this.environmental[i].detail[c].tipe == 'OPSI') {
                            if (i == 0 && c == 0) {
                                id_kegiatan = id_kegiatan + terpilih;
                                master = master + this.environmental[i].id;
                                try {
                                    detail = detail + this.environmental[i].detail[c].id;
                                } catch (error) {
                                }
                                try {
                                    tanggal = tanggal + document.getElementById('tanggalenv' + this.environmental[i].detail[c].id).value;
                                } catch (error) {
                                }
                                try {
                                    progres = progres + document.getElementById('progres' + this.environmental[i].detail[c].id).value;
                                } catch (error) {
                                }
                                try {
                                    filenya_environment = filenya_environment + document.getElementById('filenya_environmentdetail' + this.environmental[i].detail[c].id).value;
                                } catch (error) {
                                }
                                try {
                                    keterangan = keterangan + document.getElementById('keterangan' + this.environmental[i].detail[c].id).value;
                                } catch (error) {
                                }

                            }
                            else {
                                id_kegiatan = id_kegiatan + ',' + terpilih;
                                master = master + ',' + this.environmental[i].id;
                                try {
                                    detail = detail + ',' + this.environmental[i].detail[c].id;
                                } catch (error) {
                                }
                                try {
                                    tanggal = tanggal + ',' + document.getElementById('tanggalenv' + this.environmental[i].detail[c].id).value;
                                } catch (error) {
                                }
                                try {
                                    progres = progres + ',' + document.getElementById('progres' + this.environmental[i].detail[c].id).value;
                                } catch (error) {
                                }
                                try {
                                    filenya_environment = filenya_environment + ',' + document.getElementById('filenya_environmentdetail' + this.environmental[i].detail[c].id).value;
                                } catch (error) {
                                }
                                try {
                                    keterangan = keterangan + '|' + document.getElementById('keterangan' + this.environmental[i].detail[c].id).value;
                                } catch (error) {
                                }
                            }
                        }
                    }
                }
            }

            //alert(id_kegiatan);
            //alert(master);
            //alert(detail);
            //alert(tanggal);
            //alert(progres);
            //alert(filenya_environment);
            //alert(keterangan);
            //return;
            var nilaiid = '';
            var nilaiselect = '';
            var nilaitanggal = '';
            var nilaifile = '';
            for (let i = 0; i < this.datadetail.length; i++) {
                if (i == 0) {
                    nilaiid = nilaiid + this.datadetail[i].id;
                    nilaiselect = nilaiselect + document.getElementById('select' + this.datadetail[i].id).value;
                    nilaitanggal = nilaitanggal + document.getElementById('tanggal' + this.datadetail[i].id).value;
                    nilaifile = nilaifile + document.getElementById('filenya_environment' + this.datadetail[i].id).value;
                }
                else {
                    nilaiid = nilaiid + ',' + this.datadetail[i].id;
                    nilaiselect = nilaiselect + ',' + document.getElementById('select' + this.datadetail[i].id).value;
                    nilaitanggal = nilaitanggal + ',' + document.getElementById('tanggal' + this.datadetail[i].id).value;
                    nilaifile = nilaifile + ',' + document.getElementById('filenya_environment' + this.datadetail[i].id).value;
                }
            }
            //alert(kolomAWP);
            //alert(nilaiid);
            //alert(nilaiselect);
            //alert(nilaitanggal);
            //alert(nilaifile);
            //return;
            //alert(JSON.stringify(this.DIPA));


            var fd = new FormData();

            fd.append("id_kegiatan", id_kegiatan);
            fd.append("master", master);
            fd.append("detail", detail);
            fd.append("tanggal", tanggal);
            fd.append("progres", progres);
            fd.append("filenya_environment", filenya_environment);
            fd.append("keterangan", keterangan);
            fd.append("nilaiid", nilaiid);
            fd.append("nilaiselect", nilaiselect);
            fd.append("nilaitanggal", nilaitanggal);
            fd.append("nilaifile", nilaifile);
            fd.append("project_id", this.project_id);
            fd.append("updatedby", JSON.parse(localStorage.getItem("isistem")));
            fd.append("id", terpilih);

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var kode = encodeURIComponent(CryptoJS.AES.encrypt(this.secretencData, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            mainAPI.post("parastapainnovationenv-Update", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        swal.fire('Informasi', 'Data telah terupdate..', 'success').then(function () {
                            window.location.replace("/Environment/" + kode);
                        });
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )

            return false;
        },
    },
    mounted() {
        this.getOtentifikasi();
        this.initialize();
        this.ambildatareff();
        if (this.secretencData != 'Tambah') {
            this.AmbilDataSingel();
        }
        //alert(this.secretencData);
    }
}
</script>
<style></style>